import { Component, input, signal } from '@angular/core';
import { DropdownControl } from '../../../controls/setup-wizard/dropdown-control/dropdown-control';
import { FormGroup } from '@angular/forms';
import { LicenseService } from '../../../../services/license';

@Component({
	selector: 'app-product-name-dropdown-field',
	imports: [DropdownControl],
	standalone: true,
	templateUrl: './product-name-dropdown-field.html',
	styleUrl: './product-name-dropdown-field.scss',
})
export class ProductNameDropdownField {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	formGroup = input.required<FormGroup>();
	options = signal<{ value: string; label: string }[]>([]);

	constructor(private license: LicenseService) {
		this.license.getActiveProducts$().then(products => {
			this.options.set(products.map(product => ({ value: product.name, label: product.name })));
		});
	}
}
